export default __webpack_public_path__ + "images/0x06efdbff2a14a7c8e15944d1f4a48f9f95f663a4.png";